var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "870px",
    height: "870px",
    viewBox: "0 0 870 870",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "qr-code") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 870 0 870 869.94 0 869.94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr-code",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "0 870 870 870 870 0 0 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#000000",
    points: "300 90 330 90 330 60 300 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#000000",
    points: "420 90 450 90 450 60 420 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#000000",
    points: "480 90 510 90 510 60 480 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#000000",
    points: "300 120 360 120 360 90 300 90"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#000000",
    points: "390 120 420 120 420 90 390 90"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#000000",
    points: "450 120 480 120 480 90 450 90"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#000000",
    points: "480 120 510 120 510 90 480 90"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#000000",
    points: "540 120 570 120 570 90 540 90"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#000000",
    points: "300 150 390 150 390 120 300 120"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#000000",
    points: "420 150 450 150 450 120 420 120"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#000000",
    points: "450 150 480 150 480 120 450 120"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#000000",
    points: "510 150 540 150 540 120 510 120"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#000000",
    points: "330 180 360 180 360 150 330 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#000000",
    points: "450 180 480 180 480 150 450 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#000000",
    points: "510 180 570 180 570 150 510 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#000000",
    points: "300 210 330 210 330 180 300 180"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#000000",
    points: "360 210 390 210 390 180 360 180"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#000000",
    points: "450 210 480 210 480 180 450 180"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#000000",
    points: "480 210 570 210 570 180 480 180"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#000000",
    points: "390 240 450 240 450 210 390 210"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#000000",
    points: "300 270 330 270 330 240 300 240"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#000000",
    points: "360 270 390 270 390 240 360 240"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#000000",
    points: "420 270 450 270 450 240 420 240"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#000000",
    points: "480 270 510 270 510 240 480 240"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#000000",
    points: "540 270 570 270 570 240 540 240"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#000000",
    points: "450 300 480 300 480 270 450 270"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#000000",
    points: "480 300 540 300 540 270 480 270"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#000000",
    points: "60 330 90 330 90 300 60 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#000000",
    points: "150 330 330 330 330 300 150 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#000000",
    points: "420 330 450 330 450 300 420 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#000000",
    points: "480 330 540 330 540 300 480 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#000000",
    points: "570 330 600 330 600 300 570 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#000000",
    points: "660 330 690 330 690 300 660 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#000000",
    points: "720 330 810 330 810 300 720 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#000000",
    points: "180 360 210 360 210 330 180 330"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#000000",
    points: "270 360 300 360 300 330 270 330"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#000000",
    points: "330 360 360 360 360 330 330 330"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#000000",
    points: "420 360 450 360 450 330 420 330"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#000000",
    points: "480 360 570 360 570 330 480 330"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#000000",
    points: "630 360 780 360 780 330 630 330"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#000000",
    points: "150 390 180 390 180 360 150 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#000000",
    points: "210 390 300 390 300 360 210 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#000000",
    points: "330 390 360 390 360 360 330 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#000000",
    points: "420 390 450 390 450 360 420 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#000000",
    points: "510 390 600 390 600 360 510 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#000000",
    points: "690 390 720 390 720 360 690 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#000000",
    points: "780 390 810 390 810 360 780 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#000000",
    points: "60 420 90 420 90 390 60 390"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#000000",
    points: "120 420 180 420 180 390 120 390"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#000000",
    points: "270 420 300 420 300 390 270 390"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#000000",
    points: "360 420 450 420 450 390 360 390"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#000000",
    points: "480 420 540 420 540 390 480 390"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#000000",
    points: "600 420 630 420 630 390 600 390"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#000000",
    points: "690 420 810 420 810 390 690 390"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#000000",
    points: "60 450 270 450 270 420 60 420"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#000000",
    points: "300 450 330 450 330 420 300 420"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#000000",
    points: "480 450 510 450 510 420 480 420"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#000000",
    points: "540 450 570 450 570 420 540 420"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#000000",
    points: "600 450 660 450 660 420 600 420"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#000000",
    points: "780 450 810 450 810 420 780 420"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#000000",
    points: "60 480 120 480 120 450 60 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-65",
    fill: "#000000",
    points: "150 480 180 480 180 450 150 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-66",
    fill: "#000000",
    points: "300 480 360 480 360 450 300 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-67",
    fill: "#000000",
    points: "420 480 450 480 450 450 420 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#000000",
    points: "450 480 480 480 480 450 450 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    fill: "#000000",
    points: "510 480 540 480 540 450 510 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#000000",
    points: "570 480 600 480 600 450 570 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-71",
    fill: "#000000",
    points: "660 480 690 480 690 450 660 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-72",
    fill: "#000000",
    points: "750 480 780 480 780 450 750 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-73",
    fill: "#000000",
    points: "60 510 120 510 120 480 60 480"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    fill: "#000000",
    points: "150 510 270 510 270 480 150 480"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    fill: "#000000",
    points: "300 510 390 510 390 480 300 480"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#000000",
    points: "480 510 540 510 540 480 480 480"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    fill: "#000000",
    points: "570 510 630 510 630 480 570 480"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-78",
    fill: "#000000",
    points: "660 510 810 510 810 480 660 480"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-79",
    fill: "#000000",
    points: "60 540 90 540 90 510 60 510"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-80",
    fill: "#000000",
    points: "120 540 180 540 180 510 120 510"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-81",
    fill: "#000000",
    points: "300 540 390 540 390 510 300 510"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-82",
    fill: "#000000",
    points: "420 540 450 540 450 510 420 510"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-83",
    fill: "#000000",
    points: "540 540 570 540 570 510 540 510"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    fill: "#000000",
    points: "600 540 660 540 660 510 600 510"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-85",
    fill: "#000000",
    points: "690 540 750 540 750 510 690 510"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-86",
    fill: "#000000",
    points: "780 540 810 540 810 510 780 510"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-87",
    fill: "#000000",
    points: "60 570 90 570 90 540 60 540"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    fill: "#000000",
    points: "150 570 450 570 450 540 150 540"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-89",
    fill: "#000000",
    points: "450 570 480 570 480 540 450 540"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-90",
    fill: "#000000",
    points: "540 570 690 570 690 540 540 540"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-91",
    fill: "#000000",
    points: "720 570 780 570 780 540 720 540"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-92",
    fill: "#000000",
    points: "300 600 420 600 420 570 300 570"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-93",
    fill: "#000000",
    points: "450 600 480 600 480 570 450 570"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-94",
    fill: "#000000",
    points: "510 600 570 600 570 570 510 570"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-95",
    fill: "#000000",
    points: "660 600 690 600 690 570 660 570"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-96",
    fill: "#000000",
    points: "720 600 780 600 780 570 720 570"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-97",
    fill: "#000000",
    points: "300 630 330 630 330 600 300 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-98",
    fill: "#000000",
    points: "420 630 450 630 450 600 420 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-99",
    fill: "#000000",
    points: "480 630 510 630 510 600 480 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-100",
    fill: "#000000",
    points: "540 630 570 630 570 600 540 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-101",
    fill: "#000000",
    points: "600 630 630 630 630 600 600 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-102",
    fill: "#000000",
    points: "660 630 690 630 690 600 660 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-103",
    fill: "#000000",
    points: "780 630 810 630 810 600 780 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-104",
    fill: "#000000",
    points: "300 660 330 660 330 630 300 630"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-105",
    fill: "#000000",
    points: "390 660 420 660 420 630 390 630"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-106",
    fill: "#000000",
    points: "450 660 480 660 480 630 450 630"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-107",
    fill: "#000000",
    points: "480 660 570 660 570 630 480 630"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-108",
    fill: "#000000",
    points: "660 660 690 660 690 630 660 630"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-109",
    fill: "#000000",
    points: "300 690 360 690 360 660 300 660"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-110",
    fill: "#000000",
    points: "390 690 420 690 420 660 390 660"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-111",
    fill: "#000000",
    points: "450 690 480 690 480 660 450 660"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-112",
    fill: "#000000",
    points: "510 690 690 690 690 660 510 660"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-113",
    fill: "#000000",
    points: "750 690 810 690 810 660 750 660"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-114",
    fill: "#000000",
    points: "300 720 390 720 390 690 300 690"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-115",
    fill: "#000000",
    points: "420 720 450 720 450 690 420 690"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-116",
    fill: "#000000",
    points: "450 720 480 720 480 690 450 690"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-117",
    fill: "#000000",
    points: "480 720 510 720 510 690 480 690"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-118",
    fill: "#000000",
    points: "540 720 570 720 570 690 540 690"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-119",
    fill: "#000000",
    points: "600 720 630 720 630 690 600 690"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-120",
    fill: "#000000",
    points: "750 720 810 720 810 690 750 690"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-121",
    fill: "#000000",
    points: "330 750 420 750 420 720 330 720"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-122",
    fill: "#000000",
    points: "450 750 480 750 480 720 450 720"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-123",
    fill: "#000000",
    points: "540 750 600 750 600 720 540 720"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-124",
    fill: "#000000",
    points: "660 750 810 750 810 720 660 720"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-125",
    fill: "#000000",
    points: "360 780 450 780 450 750 360 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-126",
    fill: "#000000",
    points: "450 780 480 780 480 750 450 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-127",
    fill: "#000000",
    points: "630 780 690 780 690 750 630 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-128",
    fill: "#000000",
    points: "720 780 810 780 810 750 720 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-129",
    fill: "#000000",
    points: "300 810 330 810 330 780 300 780"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-130",
    fill: "#000000",
    points: "390 810 450 810 450 780 390 780"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-131",
    fill: "#000000",
    points: "450 810 480 810 480 780 450 780"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-132",
    fill: "#000000",
    points: "540 810 600 810 600 780 540 780"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-133",
    fill: "#000000",
    points: "690 810 720 810 720 780 690 780"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-134",
    fill: "#000000",
    points: "780 810 810 810 810 780 780 780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,60 L60,60 L60,270 L270,270 L270,60 L238.5,60 Z M91.5,238.5 L238.5,238.5 L238.5,91.5 L91.5,91.5 L91.5,238.5 Z",
    id: "Fill-135",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.5,60 L600,60 L600,270 L810,270 L810,60 L778.5,60 Z M631.5,238.5 L778.5,238.5 L778.5,91.5 L631.5,91.5 L631.5,238.5 Z",
    id: "Fill-136",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,600 L60,600 L60,810 L270,810 L270,600 L238.5,600 Z M91.5,778.5 L238.5,778.5 L238.5,631.5 L91.5,631.5 L91.5,778.5 Z",
    id: "Fill-137",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-138",
    fill: "#000000",
    points: "120 210 210 210 210 120 120 120"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-139",
    fill: "#000000",
    points: "660 210 750 210 750 120 660 120"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-140",
    fill: "#000000",
    points: "120 750 210 750 210 660 120 660"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.265330424dfb3744946293d5cb1a5551.svg";
export { ForwardRef as ReactComponent };